module.exports = __webpack_public_path__ + "static/media/grid_img1.2c805b84.webp";